import React from 'react';
import { motion } from 'framer-motion';
import { Lock, BookOpen, Crown, Shield, Sparkles, Zap, MessageSquare, ShieldCheck, Check } from 'lucide-react';
export function ValueStack({
  selectedBumps,
  setSelectedBumps
}: {
  selectedBumps: number[];
  setSelectedBumps: React.Dispatch<React.SetStateAction<number[]>>;
}) {
  const orderBumps = [{
    id: 0,
    title: 'EL ACELERADOR DE 7 DÍAS',
    checkboxLabel: 'SÍ, agregar EL ACELERADOR DE 7 DÍAS',
    description: 'No esperes meses. Mi plan táctico para obtener tu primera línea de crédito business de $10,000 en solo 168 horas. Paso a paso diario.',
    icon: Zap,
    price: 9,
    originalValue: 97,
    color: 'from-orange-500 to-red-500',
    borderColor: 'border-orange-500/40',
    glowColor: 'shadow-orange-500/20'
  }, {
    id: 1,
    title: 'SCRIPT "APROBACIÓN GARANTIZADA"',
    checkboxLabel: 'SÍ, incluir SCRIPT "APROBACIÓN GARANTIZADA"',
    description: 'Qué decir y qué NO decir cuando hables con el oficial del banco. Las palabras exactas que activan la confianza del algoritmo de aprobación.',
    icon: MessageSquare,
    price: 9,
    originalValue: 147,
    color: 'from-blue-500 to-cyan-500',
    borderColor: 'border-blue-500/40',
    glowColor: 'shadow-blue-500/20'
  }, {
    id: 2,
    title: 'EL ESCUDO ANTI-DEMANDAS',
    checkboxLabel: 'SÍ, proteger mi familia con EL ESCUDO ANTI-DEMANDAS',
    description: '3 Plantillas de contratos bilingües blindados (1099, No-Competencia y Arbitraje) para que ningún empleado o cliente pueda tocar tu patrimonio personal.',
    icon: ShieldCheck,
    price: 9,
    originalValue: 197,
    color: 'from-emerald-500 to-green-500',
    borderColor: 'border-emerald-500/40',
    glowColor: 'shadow-emerald-500/20'
  }];
  const getCheckoutUrl = () => {
    const base = 'https://manosquegeneran.com/cart/';
    const has0 = selectedBumps.includes(0);
    const has1 = selectedBumps.includes(1);
    const has2 = selectedBumps.includes(2);
    // No bumps → base product only
    if (!has0 && !has1 && !has2) return base + '48451070951651:1';
    // All 3 bumps
    if (has0 && has1 && has2) return base + '48451101327587:1';
    // 2 bumps combinations
    if (has0 && has1) return base + '48511860179171:1';
    if (has0 && has2) return base + '48512362250467:1';
    if (has1 && has2) return base + '48512736526563:1';
    // 1 bump only
    if (has0) return base + '48451091529955:1';
    if (has1) return base + '48451095789795:1';
    if (has2) return base + '48451096871139:1';
    return base + '48451070951651:1';
  };
  const getBumpsTotal = () => {
    return selectedBumps.reduce((total, id) => {
      const bump = orderBumps.find(b => b.id === id);
      return total + (bump ? bump.price : 0);
    }, 0);
  };
  const toggleBump = (id: number) => {
    setSelectedBumps(prev => prev.includes(id) ? prev.filter(b => b !== id) : [...prev, id]);
  };
  const items = [{
    name: 'Guía Imperio Americano (Libro Principal)',
    coverLine1: 'IMPERIO',
    coverLine2: 'AMERICANO',
    subtitle: 'El sistema completo paso a paso para escalar tu negocio en USA',
    value: 197,
    gradient: 'from-navy via-blue-900 to-navy-800',
    accent: 'gold',
    icon: Crown,
    badge: null
  }, {
    name: 'La Biblia de Bancos "Friendly" para Latinos',
    coverLine1: 'BIBLIA DE',
    coverLine2: 'BANCOS',
    subtitle: 'Los bancos exactos que aprueban a latinos con ITIN o SSN',
    value: 97,
    gradient: 'from-amber-700 via-gold-dark to-amber-800',
    accent: 'white',
    icon: BookOpen,
    badge: 'BONO #1'
  }, {
    name: 'ITIN Power: Crédito Comercial sin Social Security',
    coverLine1: 'ITIN',
    coverLine2: 'POWER',
    subtitle: 'Protocolo para obtener crédito business usando solo tu ITIN',
    value: 97,
    gradient: 'from-blue-800 via-blue-700 to-indigo-900',
    accent: 'gold',
    icon: Sparkles,
    badge: 'BONO #2'
  }, {
    name: 'Tu Escudo Legal (Manual de Contratos Pro)',
    coverLine1: 'ESCUDO',
    coverLine2: 'LEGAL',
    subtitle: 'Plantillas y contratos para blindar tu negocio legalmente',
    value: 97,
    gradient: 'from-gray-800 via-gray-700 to-gray-900',
    accent: 'gold',
    icon: Shield,
    badge: 'BONO #3'
  }];
  return <section id="pricing" className="py-8 md:py-14 bg-navy-900 relative overflow-hidden" data-id="element-194">
      <div className="absolute top-20 right-0 w-80 h-80 bg-gold/5 rounded-full blur-3xl" data-id="element-195" />
      <div className="absolute bottom-20 left-0 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl" data-id="element-196" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-198">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-199">
            <div className="h-[1px] w-10 bg-gradient-to-r from-transparent to-gold/50" data-id="element-200" />
            <span className="text-xs font-heading font-semibold text-gold/70 uppercase tracking-[0.3em]" data-id="element-201">
              Paquete Completo
            </span>
            <div className="h-[1px] w-10 bg-gradient-to-l from-transparent to-gold/50" data-id="element-202" />
          </div>
          <h2 className="text-3xl md:text-4xl text-white mb-4" data-id="element-203">
            Todo Lo Que Recibes Hoy
          </h2>
          <p className="text-gray-400 font-body text-lg" data-id="element-204">
            Un arsenal completo diseñado para tu éxito inmediato.
          </p>
        </motion.div>

        <div className="bg-navy-800/50 rounded-2xl shadow-2xl border border-white/10 overflow-hidden backdrop-blur-sm" data-id="element-205">
          <div className="p-5 md:p-10" data-id="element-206">
            <div className="space-y-5" data-id="element-207">
              {items.map((item, idx) => {
              const Icon = item.icon;
              return <motion.div key={idx} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: idx * 0.12
              }} className="flex items-center gap-4 md:gap-5 p-3 md:p-4 rounded-xl border border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.05] transition-all duration-300 group" data-id="element-208">
                    {/* Premium Book Cover */}
                    <div className="relative flex-shrink-0" data-id="element-209">
                      {item.badge && <div className="absolute -top-2 -right-2 z-20 bg-gold text-navy text-[8px] font-heading font-extrabold px-1.5 py-0.5 rounded-full shadow-lg shadow-gold/30" data-id="element-210">
                          {item.badge}
                        </div>}
                      <div className={`w-16 md:w-20 rounded-r-lg bg-gradient-to-br ${item.gradient} shadow-xl relative overflow-hidden border-l-[5px] ${item.accent === 'gold' ? 'border-gold' : 'border-white/60'} group-hover:shadow-2xl transition-shadow duration-300`} style={{
                    aspectRatio: '3/4'
                  }} data-id="element-211">
                        {/* Book shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-black/20" data-id="element-212" />
                        {/* Top decorative line */}
                        <div className={`absolute top-2 left-2 right-2 h-[1px] ${item.accent === 'gold' ? 'bg-gold/40' : 'bg-white/30'}`} data-id="element-213" />
                        {/* Icon & Cover Title */}
                        <div className="absolute inset-0 flex flex-col items-center justify-center p-1.5 md:p-2 gap-0.5" data-id="element-214">
                          <Icon className={`w-3.5 h-3.5 md:w-4 md:h-4 ${item.accent === 'gold' ? 'text-gold/70' : 'text-white/70'}`} strokeWidth={1.5} data-id="element-215" />
                          <div className={`w-5 h-[1px] my-0.5 ${item.accent === 'gold' ? 'bg-gold/30' : 'bg-white/20'}`} data-id="element-216" />
                          <div className="text-white font-heading font-extrabold text-[7px] md:text-[9px] leading-tight text-center tracking-tight" data-id="element-217">
                            {item.coverLine1}
                          </div>
                          <div className={`font-heading font-extrabold text-[7px] md:text-[9px] leading-tight text-center tracking-tight ${item.accent === 'gold' ? 'text-gold' : 'text-white/90'}`} data-id="element-218">
                            {item.coverLine2}
                          </div>
                        </div>
                        {/* Bottom decorative line */}
                        <div className={`absolute bottom-2 left-2 right-2 h-[1px] ${item.accent === 'gold' ? 'bg-gold/40' : 'bg-white/30'}`} data-id="element-219" />
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0" data-id="element-220">
                      <h4 className="font-heading font-bold text-white text-sm md:text-base leading-snug" data-id="element-221">
                        {item.name}
                      </h4>
                      <p className="text-gray-500 text-xs md:text-sm mt-1 leading-relaxed font-body hidden sm:block" data-id="element-222">
                        {item.subtitle}
                      </p>
                    </div>

                    {/* Value */}
                    <div className="flex flex-col items-end flex-shrink-0" data-id="element-223">
                      <span className="font-heading font-bold text-gray-500 line-through text-sm" data-id="element-224">
                        ${item.value}
                      </span>
                      <span className="text-[10px] text-gold/60 font-heading font-semibold uppercase tracking-wider" data-id="element-225">
                        Gratis
                      </span>
                    </div>
                  </motion.div>;
            })}
            </div>

            <div id="pricing-checkout" className="mt-10 pt-8 border-t border-white/10 text-center" data-id="element-226">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} data-id="element-227">
                <div className="text-gray-400 font-heading font-semibold mb-2" data-id="element-228">
                  Valor Total:{' '}
                  <span className="line-through text-gray-500" data-id="element-229">$488</span>
                </div>
                <div className="text-sm text-gold/80 font-bold uppercase tracking-widest mb-2" data-id="element-230">
                  Precio de Lanzamiento
                </div>
                <div className="text-6xl md:text-7xl font-heading font-extrabold text-gold mb-1" data-id="element-231">
                  ${(14.97 + getBumpsTotal()).toFixed(2)}
                </div>
                {selectedBumps.length > 0 && <p className="text-sm text-gray-400 font-heading mb-4" data-id="element-232">
                    $14.97 + {selectedBumps.length} bump
                    {selectedBumps.length > 1 ? 's' : ''} ($
                    {getBumpsTotal().toFixed(2)})
                  </p>}
                {selectedBumps.length === 0 && <div className="mb-4" data-id="element-233" />}

                {/* Order Bumps — Premium Checkout Style */}
                <div className="mb-6 rounded-xl bg-gold/[0.04] border-2 border-dashed border-gold/40 overflow-hidden" data-id="element-234">
                  {/* Header */}
                  <div className="px-4 pt-4 pb-3 border-b border-gold/20 bg-gradient-to-r from-gold/[0.06] to-transparent" data-id="element-235">
                    <div className="flex items-center gap-2.5 mb-2.5" data-id="element-236">
                      <span className="relative px-2.5 py-1 bg-red-500 text-white text-[10px] font-heading font-bold uppercase rounded-md tracking-wider shadow-sm shadow-red-500/30" data-id="element-237">
                        <span className="relative z-10" data-id="element-238">🔥 Oferta Única</span>
                      </span>
                      <span className="text-[10px] text-red-300/90 font-heading font-semibold uppercase tracking-wide animate-pulse" data-id="element-239">
                        Solo en esta página
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg font-heading font-extrabold text-gold uppercase tracking-wide leading-tight" data-id="element-240">
                      ¡Acelera tu Imperio!
                    </h3>
                    <p className="text-white/50 text-xs font-heading mt-1" data-id="element-241">
                      Oferta exclusiva de un solo clic — no estará disponible
                      después
                    </p>
                  </div>

                  {/* Bumps */}
                  <div className="p-4 space-y-3" data-id="element-242">
                    {orderBumps.map((bump, idx) => {
                    const BumpIcon = bump.icon;
                    const isSelected = selectedBumps.includes(bump.id);
                    return <div key={bump.id} onClick={() => toggleBump(bump.id)} role="button" tabIndex={0} onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') toggleBump(bump.id);
                    }} className={`w-full text-left px-3 pt-5 pb-3 sm:px-4 sm:pt-6 sm:pb-4 rounded-xl border-2 transition-all duration-300 relative overflow-hidden group cursor-pointer active:scale-[0.98] ${isSelected ? 'border-gold/70 bg-navy-800 shadow-lg shadow-gold/15 ring-1 ring-gold/20' : 'border-gold/20 bg-navy-800/80 hover:border-gold/40 hover:bg-navy-800 shadow-md shadow-black/20'}`} data-id="element-243">
                          {isSelected && <div className="absolute inset-0 bg-gradient-to-r from-gold/[0.06] via-gold/[0.02] to-transparent" data-id="element-244" />}

                          {/* Recommended badge */}
                          <div className="absolute -top-px -right-px" data-id="element-245">
                            <div className="px-2.5 py-0.5 bg-gradient-to-r from-gold to-amber-500 text-navy text-[9px] font-heading font-bold uppercase tracking-wider rounded-bl-lg rounded-tr-xl" data-id="element-246">
                              ⭐ Altamente Recomendado
                            </div>
                          </div>

                          <div className="relative z-10 flex items-start gap-3" data-id="element-247">
                            {/* Checkbox */}
                            <div className={`w-6 h-6 mt-0.5 rounded-md border-2 flex-shrink-0 flex items-center justify-center transition-all duration-300 ${isSelected ? 'bg-gold border-gold shadow-sm shadow-gold/40' : 'border-gray-500 bg-navy-900/50'}`} data-id="element-248">
                              {isSelected && <Check className="w-3.5 h-3.5 text-navy" strokeWidth={3} data-id="element-249" />}
                            </div>

                            {/* Icon */}
                            <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${bump.color} flex items-center justify-center flex-shrink-0 shadow-sm ${isSelected ? 'opacity-100 shadow-md' : 'opacity-70 group-hover:opacity-90'} transition-all`} data-id="element-250">
                              <BumpIcon className="w-4.5 h-4.5 text-white" strokeWidth={2} data-id="element-251" />
                            </div>

                            {/* Content */}
                            <div className="flex-1 min-w-0" data-id="element-252">
                              <h4 className="font-heading font-bold text-white text-sm md:text-base leading-tight" data-id="element-253">
                                {bump.checkboxLabel}{' '}
                                <span className="text-gold font-extrabold" data-id="element-254">
                                  por solo ${bump.price}
                                </span>{' '}
                                <span className="text-gray-400 line-through text-xs" data-id="element-255">
                                  (Valor ${bump.originalValue})
                                </span>
                              </h4>
                              <p className="text-gray-300 text-xs md:text-sm font-body leading-snug mt-1.5" data-id="element-256">
                                {bump.description}
                              </p>
                            </div>
                          </div>
                        </div>;
                  })}
                  </div>

                  {/* Warning + Trust */}
                  <div className="px-4 pb-4 pt-2" data-id="element-257">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 p-3 rounded-lg bg-navy-900/60 border border-white/[0.06]" data-id="element-258">
                      <p className="text-amber-300/90 text-xs md:text-sm font-heading font-semibold leading-snug text-center sm:text-left" data-id="element-259">
                        ⚠️ Esta oferta solo está disponible en esta página.
                      </p>
                      <div className="flex items-center gap-4 flex-shrink-0" data-id="element-260">
                        <div className="flex items-center gap-1.5 text-gold/80" data-id="element-261">
                          <Lock className="w-3.5 h-3.5" data-id="element-262" />
                          <span className="text-[10px] md:text-xs font-heading font-bold uppercase tracking-wider" data-id="element-263">
                            SSL Seguro
                          </span>
                        </div>
                        <div className="w-px h-4 bg-white/10" data-id="element-264" />
                        <div className="flex items-center gap-1.5 text-gold/80" data-id="element-265">
                          <ShieldCheck className="w-3.5 h-3.5" data-id="element-266" />
                          <span className="text-[10px] md:text-xs font-heading font-bold uppercase tracking-wider" data-id="element-267">
                            Verificado
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" onClick={() => {
                if ((window as any).fbq) {
                  ;
                  (window as any).fbq('track', 'AddToCart', {
                    value: 14.97 + getBumpsTotal(),
                    currency: 'USD',
                    content_name: 'Imperio Americano',
                    content_type: 'product',
                    num_items: 1 + selectedBumps.length
                  });
                }
              }} className="w-full md:w-auto px-12 py-5 bg-gold hover:bg-gold-dark text-navy font-heading font-bold text-xl rounded-xl transition-all duration-300 shadow-xl shadow-gold/20 hover:shadow-glow transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto" data-id="element-268">
                  <Lock className="w-5 h-5" data-id="element-269" />
                  Comprar Ahora — ${(14.97 + getBumpsTotal()).toFixed(2)}
                </a>
                <p className="text-gray-500 text-sm mt-4 flex items-center justify-center gap-1" data-id="element-270">
                  Pago 100% seguro y encriptado
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}